


































































































































































































































































































import { Component } from "vue-property-decorator";
import feather from "feather-icons";
import { MANAGE_SPACE_OPTIONS } from "@/resources/constants/sidebarMenu";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
import moment from "moment";
import SidebarHelpComponent from "@/app/views/nubii/components/sidebar/components/sidebarHelp.component.vue";
import CollapseButtonComponent from "@/app/views/nubii/components/sidebar/components/collapseButton.component.vue";
import { SPACES_NO_WALL } from "@/resources/constants/graphicClient/spacesNoWall";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "config-menu-component",
  components: { CollapseButtonComponent, SidebarHelpComponent },
})
export default class ConfigMenuComponent extends mixins(UserValidator, Plans) {
  feather = feather;
  MANAGE_SPACE_OPTIONS = MANAGE_SPACE_OPTIONS;
  SPACES_NO_WALL = SPACES_NO_WALL;
  compilation = moment(process.env.VUE_APP_DATE_COMPILATION)
    .utc()
    .format("DDMMYY.HHmm");
  version = process.env.VUE_APP_VERSION;
  labelsActive = true;
  wall = false;
  cameraOptions = true;
  PLAN = PLAN;
  mounted() {
    feather.replace();
    this.wall = localStorage.getItem("isWall")
      ? localStorage.getItem("isWall") === "true"
      : false;
    if (this.wall) {
      localStorage.setItem("isWall", this.wall.toString());
      this.$store.dispatch("GraphicClientStore/wallsUpdateAction", this.wall);
    }
    const cameraOptions = JSON.parse(localStorage.getItem("camera_options"));
    this.labelsActive = localStorage.getItem("space_label")
      ? localStorage.getItem("space_label") === "true"
      : true;
    if (cameraOptions !== null) {
      this.cameraOptions = cameraOptions;
      localStorage.setItem(
        "camera_options",
        this.cameraOptions ? "true" : "false"
      );
      this.$store.dispatch(
        "SystemStore/setShowCameraOptionsAction",
        this.cameraOptions
      );
    }
  }
  get config() {
    return this.$store.getters["UserStore/getConfig"];
  }
  set config(e: ConfigInterface) {
    this.$store.dispatch("UserStore/setConfigAction", e);
  }
  get configSilenceNotification() {
    return this.$store.getters["UserStore/getConfigSilenceNotification"];
  }
  set configSilenceNotification(e: boolean) {
    this.$store.dispatch("UserStore/setConfigSilenceNotificationAction", e);
  }
  get space(): SpaceInterface {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  setActiveMenu(e) {
    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", e);
    }, 500);
  }
  isMultiSpace() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space.superSpace.isExpandable;
  }
  logOut(): void {
    this.$store.dispatch("AuthStore/logOutAction");
  }
  changeVolume(e) {
    const audio = document.getElementById(
      "my-audio-element"
    ) as HTMLAudioElement;
    audio.volume = e.target.value;
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        soundLevel: parseFloat(e.target.value),
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  onChangeOpenRoomChatByDefault() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        openRoomChatByDefault: !this.config.chat.openRoomChatByDefault,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  onChangeCameraWhenJoinMeeting() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        closeCameraWhenJoinMeeting: !this.config.call.noCam,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  onChangeCloseCameraWhenJoinMeeting() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        closeMicrophoneWhenJoinMeeting: !this.config.call.noMic,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  onChangeNotificationDisabled() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isNotificationDisabled: !this.config.notification.silenceNotification,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  onChangeReactionSoundDisabled() {
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isReactionSoundDisabled: !this.config.sound.silenceReactions,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }

  graphicClientVersion(): string {
    const version =
      this.$store.getters["SystemStore/getGraphicClientVersion"].split("_");
    return (
      version[0] +
      "-" +
      moment(parseInt(version[1])).utc().format("DDMMYY.HHmm")
    );
  }
  setLabelToggle(): void {
    this.labelsActive = !this.labelsActive;
    localStorage.setItem(
      "space_label",
      this.labelsActive == true ? "true" : "false"
    );
    this.$store.dispatch(
      "GraphicClientStore/setLabelToggleAction",
      this.labelsActive
    );
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isRoomLabelActivated: this.labelsActive,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }
  setCameraOptionsActive(): void {
    this.cameraOptions = !this.cameraOptions;
    localStorage.setItem(
      "camera_options",
      this.cameraOptions ? "true" : "false"
    );
    this.$store.dispatch(
      "SystemStore/setShowCameraOptionsAction",
      this.cameraOptions
    );
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isNavigationActivated: this.cameraOptions,
      },
      callback: (response) => {
        // do nothing
      },
    });
  }
  exitNubii() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space.superSpace.id,
      callback: (response) => {
        if (response.length == 1) {
          localStorage.setItem("city", "ON");
          window.location.reload();
        } else {
          this.$store.dispatch(
            "SystemStore/setOpenChangeSpaceModalAction",
            true
          );
        }
      },
      callbackError: (error) => {
        // do nothing
      },
    });
  }
  setNoWall() {
    localStorage.setItem("isWall", this.wall.toString());
    this.$store.dispatch("GraphicClientStore/wallsUpdateAction", this.wall);
  }
  activeNoWall() {
    if (
      !this.space &&
      !this.space.scenario &&
      !this.space.scenario.scenarioType
    )
      return false;
    if (this.SPACES_NO_WALL.includes(this.space.scenario.scenarioType.name))
      return true;
    else return false;
  }
}
